<template>
    <v-card flat>
        <v-card-text>
            <v-container fluid>
                <v-form ref="form">
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-autocomplete dense label="Contratante *" color="textbox" v-model="obForm.idContratante"
                                @change="onListarAseguradora" :items="listGeneral.listContratante" 
                                item-text="contratante" item-value="idContratante" outlined 
                                :rules="requeridoRegla" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete dense label="Aseguradora *" color="textbox" v-model="obForm.idAseguradora"
                                @change="onListarSeguro" :items="listGeneral.listAseguradora" 
                                item-value="idAseguradora" item-text="aseguradora" outlined 
                                :rules="requeridoRegla" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete dense label="Seguro *" color="textbox" v-model="obForm.idSeguro"
                                @change="onListarPoliza" :items="listGeneral.listSeguro" 
                                item-value="idSeguro" item-text="seguro" outlined 
                                :rules="requeridoRegla" />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-autocomplete dense label="Póliza *" color="textbox" v-model="obForm.idPoliza"
                                :items="listGeneral.listPoliza" @change="onListarProducto"
                                item-value="id_poliza" item-text="poliza" outlined 
                                :rules="requeridoRegla" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Fecha Vigencia Desde" color="textbox" v-model="obForm.fechaVigenciaDesde"
                                outlined 
                                :rules="requeridoRegla" dense readonly />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Fecha Vigencia Hasta" color="textbox" v-model="obForm.fechaVigenciaHasta"
                                outlined 
                                :rules="requeridoRegla" dense readonly />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="8">
                            <v-autocomplete dense label="Asegurado *" color="textbox" v-model="obForm.idCliente"
                                :items="listGeneral.listCliente"
                                item-text="cliente" item-value="idCliente" outlined 
                                :rules="requeridoRegla" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <!-- <v-autocomplete dense label="Producto *" color="textbox" v-model="obForm.idProducto"
                                :items="listGeneral.listProducto" 
                                item-value="id_producto" item-text="nombre_producto" outlined 
                                :rules="requeridoRegla" /> -->
                        </v-col>
                    </v-row>

                </v-form>

                <v-row dense>
                    <v-col cols="12" sm="12">
                        <div class="text-right">
                            <v-btn rounded color="primary" class="text-right" @click="validar">Siguiente</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'StepperDatosPrincipalesComponent',
        props:{
            obModal:{
                type:Object,
                default:{}
            },
            listGeneral:{
                type:Object,
                default:{}
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        inject:['setData'],
        data: () => ({
            obForm: {
                idContratante: null,
                idAseguradora: null,
                idSeguro: null,
                idPoliza: null,
                poliza:null,
                fechaVigenciaDesde: null,
                fechaVigenciaHasta: null,
                idCliente: null,
                idProducto: null,
                idEstado:null
            }
        }),
        created(){
            this.obForm = _.merge({},this.obForm,_.omit(this.obModal,['titulo','open']))
            this.obForm.idEstado = this.parametros.idEstadoDefault;
            this.onCargaGeneral(this.obModal);
        },
        watch:{
            obModal:{
                handler(val,oldVal){
                    if(val.idCertificado != oldVal.idCertificado){
                        this.obForm = _.merge({},this.$options.data().obForm,_.omit(this.obModal,['titulo','open']));
                        this.obForm.idEstado = this.parametros.idEstadoDefault;
                        this.onCargaGeneral(val);
                    }
                },deep:true
            }
        },
        methods:{
            onCargaGeneral(obModal){
                if(!_.isUndefined(obModal.idCertificado) && !_.isNull(obModal.idCertificado)){
                var error = 'E';
                var o = _.merge({opcion:'L_ASEGURADORA_X_CONTRATANTE'}, _.pick(this.obForm,['idContratante','idEstado']));
                this.setData('listGeneral.listAseguradora',[]);
                axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.setData('listGeneral.listAseguradora',r.data.data);
                                this.setData('listGeneral.listSeguro',[]);
                                o = _.merge({opcion:'L_SEGURO_X_ASEGURADORA',idTipoPoliza:this.parametros.idTipoPolizaNormal}, _.pick(this.obForm,['idAseguradora','idContratante','idEstado']));
                                return axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                        })
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.setData('listGeneral.listSeguro',r.data.data);
                                this.setData('listGeneral.listPoliza',[]);
                                o = _.merge({opcion:'LISTAR',idTipoPoliza:this.parametros.idTipoPolizaNormal}, _.pick(this.obForm,['idAseguradora','idSeguro','idContratante','idEstado']));
                                return axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                        })
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.setData('listGeneral.listPoliza',r.data.data);
                                return this.onListarProducto('L');
                        })
                        .catch((e)=>{
                        mensajesAlerta(e,error);
                    });
                }
            },
            onListarAseguradora(e){
                if(!_.isUndefined(e)){
                    var error = 'E';
                    var o = _.merge({opcion:'L_ASEGURADORA_X_CONTRATANTE'}, _.pick(this.obForm,['idContratante','idEstado']));
                    this.reset([ 'idAseguradora','idSeguro','idPoliza','poliza','fechaVigenciaDesde','fechaVigenciaHasta']);

                    this.setData('listGeneral.listAseguradora',[]);
                    axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.setData('listGeneral.listAseguradora',r.data.data);
                         })
                         .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListarSeguro(e){
                if(!_.isUndefined(e)){
                    var error = 'E';
                    var o = _.merge({opcion:'L_SEGURO_X_ASEGURADORA',idTipoPoliza:this.parametros.idTipoPolizaNormal}, _.pick(this.obForm,['idAseguradora','idContratante','idEstado']));
                    this.reset([ 'idSeguro','idPoliza','poliza','fechaVigenciaDesde','fechaVigenciaHasta']);

                    this.setData('listGeneral.listSeguro',[]);
                    axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.setData('listGeneral.listSeguro',r.data.data);
                         })
                         .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListarPoliza(e){
                if(!_.isUndefined(e)){
                    var error = 'E';
                    var o = _.merge({opcion:'LISTAR',idTipoPoliza:this.parametros.idTipoPolizaNormal}, _.pick(this.obForm,['idAseguradora','idSeguro','idContratante','idEstado']));
                    this.reset(['idPoliza','poliza','fechaVigenciaDesde','fechaVigenciaHasta']);

                    this.setData('listGeneral.listPoliza',[]);
                    axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.setData('listGeneral.listPoliza',r.data.data);
                         })
                         .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListarProducto(e){
                if(!_.isUndefined(e)){
                    var error = 'E';
                    var obj = _.find(this.listGeneral.listPoliza,{'id_poliza':this.obForm.idPoliza});
                    this.obForm.poliza = obj.poliza;
                    this.obForm.fechaVigenciaDesde = _.get(obj,'fechaVigenciaDesde',null);
                    this.obForm.fechaVigenciaHasta = _.get(obj,'fechaVigenciaHasta',null);

                    // var o = _.merge({opcion:'LISTARCOMBO'}, _.pick(this.obForm,['idAseguradora','idSeguro','idPoliza','idEstado']));
                    
                    // this.setData('listGeneral.listProducto',[]);
                    // axios.post(`${BASE_URI}administrador/producto/listar`,o)
                    //      .then((r)=>{
                    //         if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    //         if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                    //             this.setData('listGeneral.listProducto',r.data.data);
                    //      })
                    //      .catch((e)=>{
                    //         mensajesAlerta(e,error);
                    //     });
                }
            },
            validar(){
                try {
                    if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                        this.setData('obForm.obPrincipal',this.obForm);
                        this.setData('step',2);
                } catch (e) {
                    mensajesAlerta(e,'I');
                }
            },
            reset(arrayKeys){
                _.forEach((arrayKeys),(v)=>{
                    this.$set(this.obForm,v,null);
                });
                
                if(!_.isUndefined(this.$refs.form))
                    this.$refs.form.resetValidation();
            }
        }
    }
</script>